var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215.03 85.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.63,57c8,0,10.57-2.27,10.57-8.06V13.21C11.2,7.42,8.93,5.79,0,5.79V1.51H33l-.51,4L21.26,6.92v42a34.72,34.72,0,0,1-.63,6.67l13,1.26-.5,3.78L.63,61.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.94,37.37c0-17.11-6.54-33.09-17-33.09-8.18,0-12.84,10.82-12.84,20.88,0,11.71,5.79,27.94,20.51,22l.88,4a22.64,22.64,0,0,1-11.7,3.15c-14,0-20.63-12.08-20.63-25.3C46.18,15.1,55.11,0,71.72,0,89.59,0,98.39,16.86,98.39,36c0,24.16-14.47,49.08-44.91,49.08l-.76-4.41C77.26,79.14,86.94,57.5,86.94,37.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.11,57c8,0,10.57-2.27,10.57-8.06V13.21c0-5.79-2.27-7.42-11.2-7.42V1.51h33l-.51,4-11.2,1.38v42a35.26,35.26,0,0,1-.62,6.67l13,1.26-.51,3.78-32.46.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M187.73,0C205.85,0,215,14.47,215,29.44c0,16-9.69,32.72-29.19,32.72-18.12,0-27.3-15.23-27.3-30.2C158.54,16,168.23,0,187.73,0Zm16.61,30.57c0-12.2-6.54-24.66-17.49-24.66-11.2,0-17.62,12.59-17.62,24.92,0,12.83,6.55,25.41,17.49,25.41C197.92,56.24,204.34,43.53,204.34,30.57Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.737896a4828bd6e1e4c93506a1eb3dd8.svg";
export { ForwardRef as ReactComponent };